import { Box, Button, Typography } from '@mui/material'
import { Clapperboard, Link, FileChartColumn, DollarSign, ChartNoAxesCombined, Palette } from 'lucide-react'

import { getValueProps, tailorBucket } from '../onboardingContent'
import { onboardingStyles as s, ACCENT } from '../onboardingStyles'

const ICONS = [Clapperboard, Link, DollarSign, FileChartColumn, Palette]
const ICONS_FUN = [Clapperboard, Link, ChartNoAxesCombined, Palette]

export default function ValuePropsStep({ userType, goNext }) {
    const { heading, props } = getValueProps(userType)
    const icons = tailorBucket(userType) === 'fun' ? ICONS_FUN : ICONS

    return (
        <Box>
            <Typography sx={s.title}>What Vibio can do for you</Typography>
            <Typography sx={s.subtitle}>{heading}</Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                {props.map((p, i) => {
                    const Icon = icons[i % icons.length]
                    return (
                        <Box key={p.title} sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
                            <Box
                                sx={{
                                    flexShrink: 0,
                                    width: 44,
                                    height: 44,
                                    borderRadius: '14px',
                                    backgroundColor: 'rgba(255,20,147,0.10)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <Icon size={22} color={ACCENT} />
                            </Box>
                            <Box>
                                <Typography sx={{ fontFamily: 'Catamaran', fontWeight: 800, fontSize: '1.05rem' }}>
                                    {p.title}
                                </Typography>
                                <Typography sx={{ fontFamily: 'Catamaran', color: 'text.gray', fontSize: '0.92rem' }}>
                                    {p.desc}
                                </Typography>
                            </Box>
                        </Box>
                    )
                })}
            </Box>

            <Box sx={s.footer}>
                <Button variant="contained" disableElevation onClick={goNext} sx={s.ctaButton}>
                    Continue
                </Button>
            </Box>
        </Box>
    )
}
